import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  EditUserApi,
  GetUserById,
  GetUserPermissions,
  GetAllCompanies,
  GetAllUserRoles,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const EditUser = () => {
  let param = useParams();
  const user_id_id = param.user_id;
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [companys, setCompanys] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    old_password: "",
    confirm_password: "",
    role_desc: "",
    role: "select",
    user_company: "select",
  });
  const [changePassword, setChangePassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Users");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    if (changePassword && !newErrors["password"]) {
      if (formData.password.length < 8)
        newErrors["password"] = "Please enter atleast 8 characters!";
      else if (formData.password === formData.password.toLowerCase())
        newErrors["password"] =
          "Please enter atleast one Uppercase character [A-Z]!";
      else if (formData.password === formData.password.toUpperCase())
        newErrors["password"] =
          "Please enter atleast one Lowercase character [a-z]!";
      else if (!/\d/.test(formData.password))
        newErrors["password"] =
          "Please enter atleast one decimal character [0-9]!";
      else if (formData.password !== formData.confirm_password)
        newErrors["confirm_password"] = "Confirm Password is not same!";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }

    const { SelectAll } = document.forms[0];
    var perm_ids = [];
    SelectAll.forEach((element) => {
      if (element.checked) perm_ids.push(element.value);
    });
    try {
      const response = await EditUserApi(
        user_id_id,
        formData.username,
        changePassword ? formData.password : formData.old_password,
        formData.role.value,
        formData.role_desc,
        formData.user_company === "select" ? null : formData.user_company.value,
        perm_ids,
      );
      if (response.success) {
        showSuccessToast("Success!", "User updated successfully.");
        navigate("/Users");
      } else {
        showErrorToast(
          "Error!",
          "User failed to update!\n\n" + response.message,
        );
      }
    } catch (err) {
      showErrorToast("Error!", "User failed to update!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (user_id_id) {
        TimeoutUtility.resetTimeout();
        GetAllUserRoles()
          .then((resp) => {
            const options = resp.data.map((item) => ({
              label: item.name,
              value: item.role_id,
            }));
            setRoles(options || []);
          })
          .catch((err) => console.log(err.message));
        GetAllCompanies()
          .then((resp) => {
            const options = resp.data.map((item) => ({
              label: item.name,
              value: item.company_id,
            }));
            setCompanys(options || []);
          })
          .catch((err) => console.log(err.message));
        GetUserPermissions(user_id_id)
          .then((resp) => {
            const groupedItems = resp.data.reduce(
              (acc, item) => {
                if (acc[acc.length - 1].length >= 4) return [...acc, [item]];
                acc[acc.length - 1].push(item);
                return acc;
              },
              [[]],
            );
            setPermissions(groupedItems || []);
          })
          .catch((err) => console.log(err.message));
        GetUserById(user_id_id)
          .then((result) => {
            setFormData({
              username: result.data.username,
              password: "",
              confirm_password: "",
              old_password: result.data.password,
              role_desc: result.data.role_desc,
              role: {
                label: result.data.role,
                value: result.data.role_id,
              },
              user_company: result.data.company_id
                ? {
                    label: result.data.company,
                    value: result.data.company_id,
                  }
                : "select",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [user_id_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="EDIT USER" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Username:"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Username"
                  error={errors.username}
                  compulsory={true}
                />
                <label
                  className="label-checkbox"
                  style={{ marginTop: "20px", marginBottom: "-20px" }}
                >
                  <input
                    className="checkbox"
                    name="changePassword"
                    type="checkbox"
                    value={changePassword}
                    onChange={(e) => setChangePassword(e.target.checked)}
                  />
                  {` Change Password`}
                </label>
                <TextInputField
                  label="Password:"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Password"
                  error={errors.password}
                  type="password"
                  disabled={!changePassword}
                  compulsory={true}
                />
                <TextInputField
                  label="Confirm Password:"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  placeholder="Confirm Password"
                  error={errors.confirm_password}
                  type="password"
                  disabled={!changePassword}
                  compulsory={true}
                />
                <SelectField
                  label="Role:"
                  name="role"
                  value={formData.role}
                  options={roles}
                  onChange={handleSelectChange}
                  placeholder="Role"
                  compulsory={true}
                  error={errors.role}
                />
                <SelectField
                  label="Company:"
                  name="user_company"
                  value={formData.user_company}
                  options={companys}
                  onChange={handleSelectChange}
                  placeholder="Company"
                  error={errors.user_company}
                  isClearable
                />
                <TextAreaField
                  label="Role Description:"
                  name="role_desc"
                  value={formData.role_desc}
                  onChange={handleChange}
                  placeholder="Role Description"
                  error={errors.role_desc}
                />
              </div>
            </Col>
            <Col md={8} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label mb-2">Permissions: </label>
                  {permissions.map((items, index) => (
                    <Row key={index}>
                      {items.map((item, i) => (
                        <Col key={i} md={3} style={{ paddingRight: "0px" }}>
                          <label
                            className="label-checkbox"
                            style={{ fontSize: "14px", width: "100%" }}
                          >
                            <input
                              className="checkbox"
                              name="SelectAll"
                              type="checkbox"
                              value={item.permission_id}
                              defaultChecked={item.check}
                            />
                            {` ${item.name}`}
                          </label>
                        </Col>
                      ))}
                    </Row>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditUser;
